import { render, staticRenderFns } from "./ProductFilterSimple.vue?vue&type=template&id=12da8c71&"
import script from "./ProductFilterSimple.vue?vue&type=script&lang=ts&"
export * from "./ProductFilterSimple.vue?vue&type=script&lang=ts&"
import style0 from "./ProductFilterSimple.vue?vue&type=style&index=0&id=12da8c71&prod&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports